/* eslint-disable jsx-a11y/img-redundant-alt */
// @vendors
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// @store
import useCategoryStore from "../../store/useCategoryStore"; // Importar el store de categorías
import useOnboardingStore from "../../store/useOnboardingStore"; // Store para el submit
import { useSpinnerStore } from "../../store/useSpinnerStore";
import useAuthStore from "../../store/useAuthStore";

//iconos
import {
  BoltIcon,
  WrenchScrewdriverIcon,
  PaintBrushIcon,
  BeakerIcon,
  SparklesIcon,
  KeyIcon,
  WrenchIcon,
} from "@heroicons/react/24/solid";

// @helpers
import { NextStepGuardRouteString } from "../../guards/NextStepGuard";
import { ISuggestion } from "../../types/service.types";

interface CategoryServices {
  categoryName: string;
  subCategoryId: string;
  subCategoryName: string;
  categoryId: string;
  services: { serviceId: string; serviceName: string }[];
  imageUrl: string;
}

interface ServiceOnboardingPageProps {
  onNext: () => void;
}
/* const ServiceCheckbox = ({
  isChecked,
  onClick,
  serviceName,
}: {
  isChecked: boolean;
  onClick: () => void;
  serviceName: string;
}) => (
  <div
    onClick={onClick}
    className="flex gap-2 items-center rounded-lg cursor-pointer transition-all px-4 py-2 border text-sm
      bg-white text-cTextSecondary dark:bg-dark-cBackground dark:text-dark-cTextSecondary border-cBorder border-opacity-20 select-none"
  >
    <div
      className={`min-w-[20px] min-h-[20px] w-[20px] h-[20px] flex items-center justify-center rounded
        transition-all duration-200 ease-in-out border
        ${
          isChecked
            ? "bg-bgBrand border-bgBrand"
            : "border-cBorder border-opacity-20"
        }`}
    >
      <CheckIcon
        className={`size-4  transition-all duration-200 ${
          isChecked
            ? "text-dark-cText stroke-dark-cText"
            : "text-cTextSecondary"
        }`}
      />
    </div>
    <span className="text-sm truncate overflow-hidden">{serviceName}</span>
  </div>
); */

const ServiceOnboardingPage: React.FC<ServiceOnboardingPageProps> = ({
  onNext,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { availableServices, fetchAvailableServices, isLoading } =
    useCategoryStore();
  const { submitServices, saveSuggestionByClient } = useOnboardingStore(); // Método para enviar los servicios seleccionados
  /* const [selectedServices, setSelectedServices] = useState<{
    [key: string]: string[];
  }>({}); */
  const [selectedServices, setSelectedServices] = useState<string>("")
  const [groupedSubcategories, setGroupedSubcategories] = useState<
    CategoryServices[]
  >([]);
  const { openSpinner } = useSpinnerStore();
  const { user } = useAuthStore();
  const [suggestion, setSuggestion] = useState("");

  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const handleCategoryClick = (subCategoryId: string) => {
    setSelectedCategory(subCategoryId);
  };

  useEffect(() => {
    if (isLoading) openSpinner(true);
    else openSpinner(false);
  }, [isLoading, openSpinner]);

  useEffect(() => {
    // Llamada para obtener los servicios disponibles
    fetchAvailableServices();
  }, [fetchAvailableServices]);

  // Efecto para agrupar los servicios por categorías una vez se cargan
  useEffect(() => {
    if (availableServices) {
      const grouped = availableServices.reduce(
        (acc: CategoryServices[], service) => {
          const subcategoryIndex = acc.findIndex(
            (c) => c.subCategoryId === service.subCategory.subCategoryId
          );
          if (subcategoryIndex > -1) {
            acc[subcategoryIndex].services.push({
              serviceId: service.serviceId,
              serviceName: service.serviceName,
            });
          } else {
            acc.push({
              categoryName: service.categoryName,
              categoryId: service.categoryId,
              subCategoryId: service.subCategory.subCategoryId,
              subCategoryName: service.subCategory.name,
              imageUrl: service.imageUrl,
              services: [
                {
                  serviceId: service.serviceId,
                  serviceName: service.serviceName,
                },
              ],
            });
          }
          return acc;
        },
        []
      );
      setGroupedSubcategories(grouped);
    }
  }, [availableServices]);

  // Función para manejar la selección de servicios
  const toggleServiceSelection = (subCategoryId: string, serviceId: string) => {
    /*     setSelectedServices((prev) => {
          const selectedInSubCategory = prev[subCategoryId] || []; */
    /*    if (selectedInSubCategory.includes(serviceId)) {
         return {
           ...prev,
           [subCategoryId]: selectedInSubCategory.filter(
             (id) => id !== serviceId
           ),
         };
       } */
    setSelectedServices(subCategoryId)

    return [subCategoryId]

    /* }); */
  };

  // Función para manejar el botón continuar
  const handleContinue = async () => {
    // Recolectar todos los servicios seleccionados
    /*   const allSelectedServices = Object.values(selectedServices).flat(); */
    console.log(selectedServices);

    openSpinner(true);
    try {
      await submitServices([selectedServices]); // Llamada al método de envío
      const redirectTo = NextStepGuardRouteString();
      navigate(redirectTo);
      onNext(); // Call onNext after successful submission
      openSpinner(false);
    } catch (error: any) {
      openSpinner(false);
      toast.error(t("error.postData"));
    }
  };

  // Validación para asegurarse de que cada categoría tenga al menos un servicio seleccionado
  const canContinue = () => {
    return selectedServices ? true : false
    // return Object.values(selectedServices).flat().length > 0;
  };

  // Verifica que `groupedSubcategories` no sea undefined
  if (!groupedSubcategories || groupedSubcategories.length === 0) {
    return (
      <div className="text-center">
        No se encontraron categorías disponibles.
      </div>
    );
  }

  const category = groupedSubcategories[0];

  const handleSubmitSuggestion = () => {
    const isProfessional = user?.role?.includes("PROFESSIONAL");
    const data = {
      name: suggestion,
      description: "",
      isPriority: isProfessional ? true : false,
      userType: isProfessional ? "PROFESSIONAL" : "USER",
    };
    handleSubmitSugg(data);
  };

  const handleSubmitSugg = async (data: ISuggestion) => {
    openSpinner(true);
    try {
      await saveSuggestionByClient(data);
      setSuggestion("");
      openSpinner(false);
      toast.success(t("onboarding.successSuggestion"));
    } catch (error: any) {
      openSpinner(false);
      toast.error(t("error.postData"));
    }
  };

  const iconMapping: { [key: string]: JSX.Element } = {
    Electricidad: (
      <BoltIcon
        className={`!h-8 !w-8 ${selectedCategory === "Electricidad" ? "text-white" : "text-textBrand"
          } text-textBrand`}
      />
    ),
    Jardinería: (
      <BeakerIcon
        className={`!h-8 !w-8 ${selectedCategory === "Jardinería" ? "text-white" : "text-textBrand"
          } `}
      />
    ),
    Plomería: (
      <WrenchScrewdriverIcon
        className={`!h-8 !w-8 ${selectedCategory === "Plomería" ? "text-white" : "text-textBrand"
          } `}
      />
    ),
    Pintura: (
      <PaintBrushIcon
        className={`!h-8 !w-8 ${selectedCategory === "Pintura" ? "text-white" : "text-textBrand"
          } `}
      />
    ),
    Limpieza: (
      <SparklesIcon
        className={`!h-8 !w-8 ${selectedCategory === "Limpieza" ? "text-white" : "text-textBrand"
          } `}
      />
    ),
    Cerrajería: (
      <KeyIcon
        className={`!h-8 !w-8 ${selectedCategory === "Cerrajería" ? "text-white" : "text-textBrand"
          } `}
      />
    ),
    "Mantenimiento electrodomesticos": (
      <WrenchIcon
        className={`!h-8 !w-8 ${selectedCategory === "Mantenimiento electrodomesticos"
            ? "text-white"
            : "text-textBrand"
          } `}
      />
    ),
  };

  return (
    <div className=" font-sans mt-[60px] ">
      <div className=" flex flex-col md:flex-row items-center justify-between text-center mb-8 pt-[30px]">
        <h1 className="lg:text-[18px] text-[15px] font-semibold">
          {t("onboarding.servicesSelection.title")}
        </h1>
        <div className="flex items-center gap-6 border border-cBorder border-opacity-20 rounded-lg p-4 lg:max-w-fit w-full mt-[20px] lg:mt-0">
          <div className="flex flex-col items-left justify-center text-left gap-4">
            <h3 className="text-sm font-semibold">Categoría seleccionada</h3>
            <h2 className="text-lg font-semibold">{category.categoryName}</h2>
          </div>
          <img
            src={category.imageUrl}
            alt="category photo"
            className="w-auto h-20 rounded-lg bg-cover"
          />
        </div>
      </div>

      <div className="flex justify-center lg:justify-start items-center w-full lg:mt-[60px]">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-9 gap-x-8 gap-y-6 lg:gap-12">
          {groupedSubcategories.map((subCategory, index) => (
            <div
              key={subCategory.subCategoryId}
              onClick={() => {
                toggleServiceSelection(
                  subCategory.subCategoryId,
                  subCategory.subCategoryId
                );
                handleCategoryClick(subCategory.subCategoryName);
              }}
              className={`w-32 h-32 flex flex-col items-center justify-center p-4 rounded-lg shadow-md cursor-pointer transition-transform hover:scale-105
                ${selectedCategory === subCategory.subCategoryName
                  ? "bg-bgBrand text-white"
                  : "bg-white text-gray-700"
                }`}
            >
              {/* Ícono */}
              {iconMapping[subCategory.subCategoryName] || (
                <WrenchIcon className="w-12 h-12" />
              )}

              {/* Nombre de la subcategoría (truncado si es largo) */}
              <p
                className={`mt-2 text-sm font-semibold  ${selectedCategory === subCategory.subCategoryName
                    ? "text-white"
                    : "text-gray-700"
                  } truncate w-full text-center`}
              >
                {subCategory.subCategoryName}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Botón Continuar */}
      <div className="grid grid-cols-1 md:grid-cols-2 items-center mt-8  mx-auto relative lg:absolute lg:bottom-[40px] lg:left-10 lg:right-10">
        <div className="w-full flex flex-col lg-flex-row lg:flex-col items-start gap-4 border p-2 lg:p-4 rounded-lg text-cTextSecondary dark:text-dark-cTextSecondary border-bgBrand/30 shadow-lg">
          <p className="leading-loose text-[12px] lg:text-[14px]">
            {t(
              "En esta lista no está el servicio que ofreces? No te preocupes, ingresalo aqui y en el menor tiempo posible estará en la lista."
            )}
          </p>
          <div className="flex justify-between items-center w-full gap-4">
            <input
              type="text"
              value={suggestion}
              onChange={(e) => setSuggestion(e.target.value)}
              placeholder="Ingresa el servicio que ofreces"
              className="border p-2 text-[12px] lg:text-[14px] rounded-lg placeholder:text-cTextSecondary placeholder:dark:text-dark-cTextSecondary w-3/4"
            />
            <button
              type="submit"
              onClick={handleSubmitSuggestion}
              className="bg-bgBrand hover:bg-bgBrandHover text-textOnBrand px-4 text-[12px] lg:text-[14px] py-3 h-fit rounded-lg w-1/4 text-center"
            >
              {t("ENVIAR")}
            </button>
          </div>
        </div>
        <button
          className={`mt-[20px] lg:mt-[0px]  w-full lg:w-[200px] flex self-end justify-self-end justify-center px-16 py-3 h-fit rounded-lg  text-center mb-8 ${canContinue()
              ? "bg-bgBrand hover:bg-bgBrandHover text-textOnBrand"
              : "bg-cTextSecondary text-textOnBrand disabled:opacity-50"
            }`}
          onClick={handleContinue}
          disabled={!canContinue()} // Deshabilitado hasta que todas las categorías tengan un servicio seleccionado
        >
          {t("Continuar")}
        </button>
      </div>
    </div>
  );
};

export default ServiceOnboardingPage;
